// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3fabbe41","32":"3e34621e","163":"28009090","419":"bdc4c775","601":"254cd64d"}[chunkId] + ".chunk.js";
};